import config from "config/config";

const CHAT_PARAM = "data";
const CHAT_PARAM_VALUE = "chat";
const CHAT_ICON =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxjaXJjbGUgY3g9IjMwIiBjeT0iMjkuOCIgcj0iMzAiIGZpbGw9IiMxQjhFRkYiLz4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgIDxwYXRoIGQ9Ik00My41NzEgMjIuMmgtMy40Mjh2Ni42MmMwIDMuNjU2LTMuMDcgNi42Mi02Ljg1NyA2LjYySDIzdjEuNjU1YzAgMS44MiAxLjU0MyAzLjMxIDMuNDI5IDMuMzFoMTUuNDI4bDMuNjc5IDMuNTVjLjU0LjUyMiAxLjQ2NC4xNTMgMS40NjQtLjU4M1YyNS41MWMwLTEuODItMS41NDMtMy4zMS0zLjQyOS0zLjMxeiIvPgogICAgICA8cGF0aCBkPSJNMzMuNTcxIDE0LjJIMTYuNDNDMTQuNTQzIDE0LjIgMTMgMTUuNjkgMTMgMTcuNTF2MTcuODZjMCAuNzM3LjkyNCAxLjEwOCAxLjQ2NC41ODZsMy42NzktMy41NTNIMzMuNTdjMS44ODYgMCAzLjQyOS0xLjQ4OSAzLjQyOS0zLjMxVjE3LjUxYzAtMS44Mi0xLjU0My0zLjMxLTMuNDI5LTMuMzF6Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";

const shouldOpenChatAfterLoad = (query) => query && query[CHAT_PARAM] === CHAT_PARAM_VALUE;

const getSupChatConfig = () => ({
  supchat_url: config.supWizChatWidgetUrl,
  supchatWidgetUrl: `${config.supWizChatWidgetUrl}/widget/`,
  tenant: "airhelp",
  cookieDomain: ".airhelp.com",
  title: "AirHelp Live Chat",
  image: {
    src: `${config.staticUrl}/i/images/ah-logo.svg`,
    style: "height: 32px !important; margin-top: 8px !important",
  },
  language: "en",
  customChatBtnIcon: CHAT_ICON,
  allowNotification: true,
  startIfOngoingChat: false,
  subtitle:
    "Hi! How can we help you today?<br/>We'll connect you with an agent in just a moment. Your conversation may be translated automatically by a machine (but you'll still talk to a real person).",
  outsideOpenHoursMsg:
    "Hi, thank you for contacting AirHelp!<br/>Our team is not here right now.<br/>Although we are usually available 24/7, it may sometimes happen that we must close the chat for a while. Please check the office hours below.<br/>Talk to you soon!",
  visitorInfo: {
    fields: [
      {
        name: "name",
        type: "text",
        placeholder: "Insert here your Name",
        required: true,
        defaultValue: "",
      },
      {
        name: "email",
        type: "text",
        placeholder: "Insert here your Email Address",
        required: true,
        defaultValue: "",
      },
    ],
    displayName: "#name",
  },
  styles: {
    fontFamily: '"Source Sans Pro",sans-serif',
    primaryColor: "#1B8EFF",
    secondaryColor: "#1B8EFF",
    fontSizes: {
      general: "14px",
      header: "18px",
      wSubtitle: "14px",
      wDisclaimer: "14px",
      inputs: "14px",
    },
  },
  bottom: 8,
  right: 8,
});

const bootSupChat = (isOpen: boolean) => {
  const scriptSrc = `${config.supWizChatWidgetUrl}/widget/main.js`;
  const script = document.querySelector(`script[src="${scriptSrc}"]`);
  const supChatTriggerElement = document.getElementById("supchat-trigger");

  if (!script) {
    const supChatConfig = getSupChatConfig();
    const configureWidgetCallback = (widget) => isOpen && widget.toggleWidget();

    const widgetScriptTag = document.createElement("script");
    widgetScriptTag.type = "text/javascript";
    widgetScriptTag.src = scriptSrc;
    supChatTriggerElement.style.opacity = "0.5";

    // @ts-ignore
    widgetScriptTag.onload = () => window.configureWidget(supChatConfig, null, configureWidgetCallback);

    document.head.appendChild(widgetScriptTag);
  }
};

export { bootSupChat, shouldOpenChatAfterLoad };
